import { fileBaseUrl } from "../../constants";

// education-hub media paths
export const gaVideoUrl = fileBaseUrl + "/static/media/general/video/See GA Differently DSE- Visual progression of GA video.mp4"
export const gaThumbnailUrl = fileBaseUrl + "/static/media/general/video/See GA Differently DSE- Visual progression of GA video.png"
export const complementPathwayVideoUrl = fileBaseUrl + "/static/media/general/video/ComplementAnimation_Hypercept.mp4"
export const complementPathwayThumbnailUrl = fileBaseUrl + "/static/media/general/video/ComplementAnimation_Hypercept.png"


// home footer media paths
export const caringForSomeoneWithGeographicAtrophy = fileBaseUrl + "/static/media/general/pdf/Caring for Someone with Geographic Atrophy.pdf"
export const livingWithGeographicAtrophyLeaflet = fileBaseUrl + "/static/media/general/pdf/Living with Geographic Atrophy Leaflet.pdf"


// education-hub file paths
export const identifyingGAFilePath = fileBaseUrl + "/static/media/general/pdf/Astellas Ophthalmics DSE GA Infographic-By the Numbers.pdf"
export const collaboratingCollegueFilePath = fileBaseUrl + "/static/media/general/pdf/Ophthalmic DSE Patient Identification and Referral Guide.pdf"
export const gaResourceFilePath = fileBaseUrl + "/static/media/general/pdf/Astellas Ophthalmics DSE GA Infographic-By the Numbers.pdf"

// other links
export const dataPrivacyLink = "https://www.astellas.com/en/privacy-notice-for-the-processing-of-personal-information-of-healthcare-professionals"